import {AxjHandler} from '../ts-lib/ajax';
import {QueryItem, TopItemsParams} from '../interfaces/shortcodes';
import {createListItem} from '../class-lib/global-functions';
import {mkEl} from '../ts-lib/functions';

export class StaTop3 extends AxjHandler {

    params: TopItemsParams;
    container: HTMLElement;
    items_row: HTMLElement;
    title_row: HTMLElement;

    constructor(container: HTMLElement) {
        super();
        this.setLocalizedParameters('ajaxDataMain');
        this.container = container;
        this.init();
    }

    init() {
        if (this.container) {
            let params = this.container.dataset.params;
            if (params) {
                this.params = JSON.parse(params);
            }
            this.items_row = this.container.querySelector('.items-row')
            this.title_row = this.container.querySelector('.sta-heading')
        }

        if (this.params) {
            this.loadTopItems();
        }
    }

    loadTopItems() {
        let postData = {
            action: 'sta_top_items_action',
            nonce: this.params.nonce,
            params: this.params
        };
        this.initLoader();
        jQuery.ajax({
            type: "POST",
            data: postData,
            dataType: "json",
            url: this._ajaxUrl,
            success: (items) => {
                this.removeLoader();
                if (items) {
                    this.renderList(items);
                }
            }
        }).fail((data) => {
            this.removeLoader();
            console.error(data);
        });
    }

    initLoader() {
        this.items_row.innerHTML = '';
        this.items_row.append(
            mkEl('div', {class: ['sta-loader'], append: [mkEl('div', {class: ['spinner']})]})
        );
    }

    removeLoader() {
        this.items_row.innerHTML = '';
    }

    renderList(items: QueryItem[]) {
        if (this.items_row && items && items.length) {
            let cls = parseInt(this.params.count) === 3 ? 'col-lg-4' : 'col-lg-3';
            const cnt = mkEl('div', {class: ['row', 'no-gutters', 'results-row', 'm-bottom-15']});
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                let li = createListItem(item, cls);
                cnt.appendChild(li);
            }
            this.items_row.innerHTML = '';
            this.items_row.append(cnt);

            if (this.title_row && this.params.title) {
                this.title_row.innerHTML = '';
                this.title_row.append(mkEl('h3', {text: this.params.title}))
            }
        }
    }
}